import {
    call, put, takeEvery, select,
} from 'redux-saga/effects';
import { message } from 'antd';
import { setFinalConfirmation } from '../../requests/final_confirmation_request';
import { SET_FINAL_CONFIRMATION } from '../constants/final_confirmation.constants';
import { setFinalConfirmationFailure, setFinalConfirmationSuccess } from '../actions/final_confirmation.actions';
import { READ_LEAD_PROFILE_LEAD_FINANCE } from '../constants/lead_profile_lead_finance.constants';
import { getVal } from '../../../../../shared/helpers';

function* setFinalConfirmationRequest({ params }) {
    const { result, options, error } = yield call(setFinalConfirmation, params);

    if (result) {
        const lead_id = yield select(state => getVal(state, 'Leads.Lead_profile.Lead_general.root_id'));

        yield put(setFinalConfirmationSuccess(options));

        yield put({ type: READ_LEAD_PROFILE_LEAD_FINANCE, params: { lead_id } });
        message.success('Accounts data saved successfully');
    } else {
        yield put(setFinalConfirmationFailure(error));
        message.error(error && (error.message || error.msg));
    }
}

export default function* setFinalConfirmationSaga() {
    yield takeEvery(SET_FINAL_CONFIRMATION, setFinalConfirmationRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/set_final_confirmation.saga.js